import { Alert, Card, CardContent, CardHeader, CardTitle } from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { C2EddyLoadsJournal } from './C2EddyLoadsJournal';
import { C2EddyPeriodLoad } from './C2EddyPeriodLoad';

type Props = {
  /** Интеграция включена; выключенной поиск, загрузка и журнал недоступны */
  isActive: boolean;
};

/**
 * Блок карточки интеграции c2_eddy: поиск закрытых обращений HelpDeskEddy за период, загрузка
 * всего периода и журнал загрузок.
 */
export const C2EddySection: FC<Props> = ({ isActive }) => {
  const { t } = useTranslation(['integrations']);

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-xl">{t('integrations:c2Eddy.title')}</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-6">
        <p className="text-muted-foreground text-sm">{t('integrations:c2Eddy.description')}</p>
        {/* Выключенной интеграции сервер отказывает во всех запросах блока — они и не уходят */}
        {isActive ? (
          <>
            <C2EddyPeriodLoad />
            <C2EddyLoadsJournal />
          </>
        ) : (
          <Alert type="warning" title={t('integrations:c2Eddy.inactive')} />
        )}
      </CardContent>
    </Card>
  );
};
